var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconHeart05 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 10"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M10.831.884a3.017 3.017 0 0 0-4.267 0l-.582.581-.581-.58A3.017 3.017 0 1 0 1.134 5.15l.581.582L5.982 10l4.268-4.267.581-.582a3.016 3.016 0 0 0 0-4.267"
})));
export default SvgIconHeart05;